exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".container {\n  margin: 0 auto;\n  box-sizing: content-box;\n  padding: 0 1.50rem;\n  width: 60rem; }\n  .container .result {\n    float: left;\n    box-sizing: border-box;\n    padding: 0 0.75rem;\n    width: 40rem; }\n    .container .result ul {\n      margin-top: 0; }\n  .container div.calendar {\n    float: left;\n    box-sizing: border-box;\n    padding: 0 0.75rem;\n    margin-left: 40rem;\n    position: fixed;\n    width: 20rem; }\n\n.sentinel {\n  text-align: center;\n  margin: 2.5rem 0 3.5rem; }\n\n.no-items {\n  padding: 3.5rem 0; }\n  .no-items p {\n    text-align: center;\n    color: #9e9e9e; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/main.component.scss
// module id = 246
// module chunks = 0